import { Injectable } from '@angular/core'
import { map } from 'rxjs'
import { ComponentsRepository } from 'src/domain/repositories/component.repository'
import { DefaultResultData } from '../entities/base.entity'
import { MenuItemTypeEntity } from '../entities/component.entity'
import { MenuItemMapper } from '../mappers/component/menu-item.mapper'

@Injectable({
	providedIn: 'root',
})
export class ComponentsImplementationRepository extends ComponentsRepository {
	menuItemMapper = new MenuItemMapper()

	GetMenuItem() {
		return this.get<DefaultResultData<MenuItemTypeEntity[]>>('api/Components').pipe(
			map((response) => {
				return response.data.map((item) => {
					return this.menuItemMapper.mapFrom(item)
				})
			}),
		)
	}
}
